namespace Matrix.Exceptions {
    export class ExceptionReviewColumns {
        static columnsKey = 'Exceptions.ExceptionReview';
    }
}
